// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"397":"1482b245","518":"6b9e034d","520":"09223c4d","555":"4224396f","724":"e9ff7d20","787":"1fb4d789"}[chunkId] + ".chunk.css";
};